import anewSignIn from './anewSignIn';
import Logger from './Logger';

export interface Subject {
  id: string;
  name: string;
}

export function hasSubject() {
  return !!localStorage.getItem('subject');
}

/**
 * @returns 没有获取到学科时会跳转到登录页
 */
export function getSubject(): Subject {
  const subjectStr = localStorage.getItem('subject');
  if (subjectStr) {
    try {
      return JSON.parse(subjectStr) as Subject;
    } catch (e) {
      Logger.error(e);
    }
  }

  anewSignIn('没有选择学科，请重新登录');

  return { id: '', name: '' };
}

export function setSubject(subject: Subject) {
  localStorage.setItem('subject', JSON.stringify(subject));
}
